import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            <span>话题讨论</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题 · 漫友都在讨论什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            社区最热话题标签，看看大家都在追什么聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-full px-5 py-3 cursor-pointer hover:bg-primary-50 transition-colors duration-200 flex items-center gap-2"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}